import script from "./DividerLabeled.vue?vue&type=script&lang=js"
export * from "./DividerLabeled.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__